import script from "./InvoiceGroups.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceGroups.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceGroups.vue?vue&type=style&index=0&id=4165636f&scoped=true&lang=css"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4165636f"]])

export default __exports__